import alerts from '@/broilerAdmin/store/alerts.js';

export default {
  namespaced: true,

  modules: {
    alerts,
  },
}



// WEBPACK FOOTER //
// ./src/broilerAdmin/storeModule.js